export default __webpack_public_path__ + "static/media/Copy of 46265_28-51_tn.aa07a7ed.jpg";